import { Flex } from 'src/components/Flex/Flex';
import styled from 'styled-components';

export const FlexContent = styled(Flex)`
  padding: 0 2em;
`;



// WEBPACK FOOTER //
// ./src/components/FlexContent/FlexContent.tsx